/** @format */

'use strict';

angular
	.module('emsApp')
	.controller('UserRelationListDtoTabController', function(
		$scope,
		$rootScope,
		$state,
		$stateParams,
		$q,
		AlertService,
		RelationFactory,
		UserRelationListDtoSearchFactory,
		UserRelationViewDtoFactory
	) {
		$scope.relationList = [];
		$scope.selectedRelationList = [];
		$scope.showSearchForm = true;
		$scope.totalCountIsKnownAtTheMoment = false;

		if ($rootScope.isDefinedAndNotNull($rootScope.pageSizeRelation)) {
			$scope.pageSize = angular.copy($rootScope.pageSizeRelation);
		} else {
			$scope.pageSize = 20;

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);
		}

		$scope.goToNewState = function() {
			// this overview is in a tab and mapped by $scope.mappedBy / $scope.mappedById
			$state.go('user-relation.new', { mappedBy: $scope.mappedBy, mappedById: $scope.mappedById });
		};

		var getCompanyTypeId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.companyTypeId)) {
				return $scope.companyTypeId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.companyType)) {
				return $scope.RelationSearchTab.companyType.id;
			} else {
				return undefined;
			}
		};

		var getAccountManagerId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.accountManagerId)) {
				return $scope.accountManagerId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.accountManager)) {
				return $scope.RelationSearchTab.accountManager.id;
			} else {
				return undefined;
			}
		};

		var getBusinessCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.businessCountryId)) {
				return $scope.businessCountryId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.businessCountry)) {
				return $scope.RelationSearchTab.businessCountry.id;
			} else {
				return undefined;
			}
		};

		var getPrivateCountryId = function() {
			if ($rootScope.isDefinedAndNotNull($scope.privateCountryId)) {
				return $scope.privateCountryId;
			} else if ($rootScope.isDefinedAndNotNull($scope.RelationSearchTab.privateCountry)) {
				return $scope.RelationSearchTab.privateCountry.id;
			} else {
				return undefined;
			}
		};

		// handle attribute carRentalAgreementSigned of javaType Boolean
		// handle attribute indemnificationSigned of javaType Boolean

		$scope.search = function() {
			$scope.totalCountIsKnownAtTheMoment = false;
			$('#search-button').addClass('glyphicon-refresh-animate');

			$rootScope.RelationSearchTab = angular.copy($scope.RelationSearchTab);

			$rootScope.pageSizeRelation = angular.copy($scope.pageSize);

			UserRelationListDtoSearchFactory.query(
				{
					page: $scope.RelationSearchTab.page - 1,
					size: $scope.pageSize,
					externalId: $scope.RelationSearchTab.externalId,
					companyName: $scope.RelationSearchTab.companyName,
					firstName: $scope.RelationSearchTab.firstName,
					lastName: $scope.RelationSearchTab.lastName,
					email: $scope.RelationSearchTab.email,
					telephone: $scope.RelationSearchTab.telephone,
					mobile: $scope.RelationSearchTab.mobile,
					potentialFrom: $scope.RelationSearchTab.potentialFrom,
					potentialTo: $scope.RelationSearchTab.potentialTo,
					carRentalAgreementSigned: $scope.RelationSearchTab.carRentalAgreementSignedGroup,
					indemnificationSigned: $scope.RelationSearchTab.indemnificationSignedGroup,
					type: $scope.RelationSearchTab.type,
					companyTypeId: getCompanyTypeId(),
					relationSource: $scope.RelationSearchTab.relationSource,
					gender: $scope.RelationSearchTab.gender,
					clientOf: $scope.RelationSearchTab.clientOf,
					accountManagerId: getAccountManagerId(),
					businessCountryId: getBusinessCountryId(),
					privateCountryId: getPrivateCountryId(),
					langKey: $scope.RelationSearchTab.langKey,

					sort: [$scope.RelationSearchTab.predicate + ',' + ($scope.RelationSearchTab.ascending ? 'asc' : 'desc')],
				},
				function(result, headers) {
					$scope.totalItems = headers('X-Total-Count');
					$scope.totalCountIsKnownAtTheMoment = true;
					$scope.relationList = result.items;

					$scope.accountManagerReferenceFilterList = result.accountManagerSearchOptions;

					$('#search-button').removeClass('glyphicon-refresh-animate');
				}
			);
		};

		$scope.isRelationSearchTabDirty = function() {
			return !angular.equals($scope.RelationSearchTab, $scope.originalRelationSearchTab);
		};

		$scope.loadDefaultSearchParams = function() {
			$rootScope.RelationSearchTab = {};
			$rootScope.RelationSearchTab.page = 1;
			$rootScope.RelationSearchTab.predicate = 'id';
			$rootScope.RelationSearchTab.ascending = false;

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);

			$scope.originalRelationSearchTab = angular.copy($scope.RelationSearchTab);
		};

		$scope.reset = function() {
			$scope.loadDefaultSearchParams();
			if ($rootScope.isDefinedAndNotNull($scope.searchForm)) {
				// we check the availability of search form as it is still used in search forms that are not inlined in the table
				$scope.searchForm.$setPristine();
			}
			$scope.search();
		};

		$scope.loadPage = function() {
			if (angular.isUndefined($rootScope.RelationSearchTab) || $rootScope.RelationSearchTab === null) {
				$scope.loadDefaultSearchParams(); // load defaults
			}

			$scope.RelationSearchTab = angular.copy($rootScope.RelationSearchTab);

			$scope.search();
		};

		$scope.singleDelete = function(id) {
			$scope.selectedRelationId = id;
			$('#deleteRelationConfirmationInTab').modal('show');
		};

		$scope.confirmSingleDelete = function() {
			UserRelationViewDtoFactory.delete(
				{ id: $scope.selectedRelationId },
				function() {
					$scope.search();
					$('#deleteRelationConfirmationInTab').modal('hide');
				},
				function(error) {
					$('#deleteRelationConfirmationInTab').modal('hide');
					AlertService.error(error.data.message, error.data.params);
				}
			);
		};

		$scope.multipleUpdate = function() {
			$state.go('user-relation.bulkedit', { selectedRelationList: $scope.selectedRelationList });
		};

		$scope.deselectAll = function() {
			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				value.isSelected = false;
				$scope.selectionChanged(value);
			});
			$scope.selectedRelationList = [];
		};

		$scope.selectionChanged = function(item) {
			$scope.$broadcast('childClick', item);
			$scope.updateSelection();
		};

		$scope.toggleSelection = function() {
			$scope.updateSelection();
		};

		$scope.updateSelection = function() {
			// clean selection (if any)
			$scope.selectedRelationList = [];

			angular.forEach($scope.relationList, function(value, key) {
				// update the list with selected items
				if (value.isSelected) {
					$scope.selectedRelationList.push(value);
				}
			});
		};

		// the dialog controller can emit an event to update the overview, here we react on it
		$rootScope.$on('emsApp:relationUpdate', function() {
			$scope.loadPage();
		});

		$scope.loadPage();

		$scope.getSortIcon = function(itemName) {
			if ($scope.RelationSearchTab.predicate === itemName) {
				if ($scope.RelationSearchTab.ascending) {
					return 'glyphicon-sort-by-attributes';
				} else {
					return 'glyphicon-sort-by-attributes-alt';
				}
			} else {
				return 'glyphicon-sort';
			}
		};
	});
